import { cn } from "@/lib/cn";

/**
 * Workshop: Floating agent subtitle bar — shows which agent is active.
 */

interface AgentSubtitleBarProps {
  agentName: string;
  actionText?: string;
  dotColor?: string;
  className?: string;
  "data-testid"?: string;
}

export function AgentSubtitleBar({
  agentName,
  actionText,
  dotColor = "bg-accent",
  className,
  "data-testid": testId,
}: AgentSubtitleBarProps) {
  return (
    <div
      className={cn(
        "flex h-7 items-center gap-2 rounded-full border border-glass-stroke bg-glass-fill px-3 shadow-glass backdrop-blur-glass-sm",
        className,
      )}
      data-testid={testId}
    >
      <span
        className={cn("h-1.5 w-1.5 shrink-0 rounded-full", dotColor)}
        aria-hidden="true"
      />
      <span className="text-canvas-md font-semibold text-primary">{agentName}</span>
      {actionText && (
        <span className="truncate text-canvas-md text-secondary">{actionText}</span>
      )}
    </div>
  );
}

export type { AgentSubtitleBarProps };
